module.exports = __webpack_public_path__ + "static/media/improve.3ab49674.jpg";